import React from "react";
import { Button } from "../ui/Button";
import { VideoPlayer } from "../ui/VideoPlayer";
import type { HeroSection as HeroSectionType } from "../../types/content.types";

interface HeroSectionProps {
  content: HeroSectionType;
  onCtaClick: () => void;
}

export function HeroSection({ content, onCtaClick }: HeroSectionProps) {
  return (
    <section className="bg-black pt-16 pb-20 px-4">
      <div className="w-full max-w-6xl mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Main Heading */}
          <h1 className="text-[#a79c68] leading-tight max-w-4xl text-4xl sm:text-7xl lg:text-8xl">
            <span className="block">
              <span className="font-bold">4×4 Gear</span>{" "}
              <span className="font-normal">For</span>
            </span>
            <span className="font-normal block">
              Avid Adventurers
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl sm:text-2xl text-white leading-tight">
            <span className="block">
              <span className="font-normal">Tried and tested for </span>
              <span className="font-bold">African</span>
            </span>
            <span className="font-bold block">Conditions</span>
          </p>

          {/* Video */}
          <div className="w-full max-w-md">
            <VideoPlayer
              key={content.video}
              videoUrl={content.video}
              posterUrl={content.videoPoster}
              title={content.heading}
              autoplay={true}
            />
          </div>

          {/* CTA Button */}
          <div className="flex justify-center mt-6">
            <Button variant="primary" size="lg" onClick={onCtaClick}>
              {content.ctaText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
